import React from 'react';
import { CheckCircle } from 'lucide-react';
const includes = ['Guía de decisiones clínicas', 'Plantillas listas para usar', 'Sistema de organización real', 'Aplicación paso a paso', 'Uso en guardia', 'Seguridad en la práctica'];
export function AulaListaSection() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-30">
      <div className="max-w-xl mx-auto" data-id="element-31">
        <div className="text-center mb-8" data-id="element-32">
          <span className="bg-brand-yellow/15 text-brand-yellow text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wide mb-4 inline-block border border-brand-yellow/30" data-id="element-33">
            ⭐ EXCLUSIVO DEL PACK COMPLETO
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3" data-id="element-34">
            🧠 ¿Qué agrega el Sistema Enfermería Lista™?
          </h2>
          <p className="text-sm text-gray-400 font-medium max-w-md mx-auto" data-id="element-35">
            Ya entendés lo teórico…{' '}
            <span className="text-brand-yellow font-bold" data-id="element-36">
              👉 esto te da cómo actuar en la práctica
            </span>{' '}
            y organizar tu trabajo real.
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 mb-8" data-id="element-37">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-5" data-id="element-38">
            💥 ESTO INCLUYE EL SISTEMA:
          </h3>
          <div className="space-y-3" data-id="element-39">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-white/5 p-3 rounded-lg border border-white/5" data-id="element-40">
                <CheckCircle className="text-brand-yellow flex-shrink-0" size={20} data-id="element-41" />
                <span className="text-sm font-semibold text-white" data-id="element-42">{item}</span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-gray-500 text-xs font-medium" data-id="element-43">
          La opción más recomendada para resultados más completos
        </p>
      </div>
    </section>;
}